export function ShimmerBroadcastCard({ count = 1, className = "" }) {
  return (
    <div className={`space-y-4 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="p-4 border rounded bg-white border-gray-200">
          <div className="relative flex rounded-xl overflow-hidden h-140 w-full bg-gray-100 shadow select-none animate-pulse">

            <div className="absolute inset-0 z-10 pointer-events-none">
              <div
                className="h-full w-full"
                style={{
                  background: `linear-gradient(110deg, #f3f4f6 8%, #e5e7eb 18%, #f3f4f6 33%)`,
                  backgroundSize: '200% 100%',
                  animation: 'shimmer-move 1.2s linear infinite',
                }}
              />
            </div>
            <div className="flex-1 flex flex-row items-center z-20 relative px-6 gap-6">
              <div className="flex flex-col items-center justify-center w-1/2 h-full gap-4">
                <div className="rounded-full bg-gray-200 w-16 h-16" />
                <div className="rounded-full bg-gray-200 w-20 h-4" />
                <div className="rounded bg-gray-200 w-12 h-4" />
              </div>
              <div className="flex-1 flex flex-col gap-2 justify-center">
                <div className="h-6 bg-gray-200 rounded w-2/3 mb-2" />
                <div className="h-4 bg-gray-200 rounded w-1/3 mb-1" />
                <div className="h-3 bg-gray-200 rounded w-1/2 mb-1" />
                <div className="h-2 bg-gray-200 rounded w-full" />
              </div>
            </div>
            <style>{`
              @keyframes shimmer-move {
                0% { background-position: -200% 0; }
                100% { background-position: 200% 0; }
              }
            `}</style>
          </div>
        </div>
      ))}
    </div>
  );
}
